import React, { useContext } from 'react';
import styles from './SearchBarReportYearSelect.module.scss';
import { AppContext } from '../../../context/AppContext';

const SearchBarReportYearSelect = () => {
  const appContext = useContext(AppContext);

  return (
    <div className={styles.reportYearSelectContainer}>
      <select
        className={styles.reportYearSelect}
        value={appContext.reportYear}
        onChange={(e) => {
          appContext.updateReportYear(Number(e.target.value));
        }}
      >
        <option value={2026}>2026</option>
        <option value={2027}>2027</option>
      </select>
    </div>
  );
};

export default SearchBarReportYearSelect;